import { useEffect, useState } from 'react'
import { Empty, Skeleton, Table, Popconfirm } from 'antd'
import { map, get } from "lodash";

import { recordError } from "../../../utils/logService";
import service from '../../../services/documentRepoService'

import {
  CheckboxSwitchery,
  Messages,
  Notify,
  openNotification,
  SearchControl,
  util
} from '@seims/shared';

export default function RepoLookupList(props) {

    const { hasUpdated, setHasUpdated, showModal, organisationTypes } = props;
    const sortDirections = ['ascend', 'descend', 'ascend'];
    const initTab = "types";
    let msg = "";

    const [visible, setVisible] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(true);
    const [repoDropdownOptions, setRepoDropdownOptions] = useState([]);

    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [currentTab, setCurrentTab] = useState(initTab);

    useEffect(() => {
        if (hasUpdated === true) {
            getDocumentDropdowns();
        }
    }, [hasUpdated])

    const getDocumentDropdowns = async () => {
        try {
            setLoading(true);
            setSearchText("");
            const response = await service.getDocumentDropdowns();
            if (response && response.status === 200) {
                const { data } = response;
                const dropdowns = data.map((d) => {
                    d.dropdown = d.dropdown.replace("Organization - ", "");
                    return d;
                })
                .sort((a, b) => b.id - a.id);
                setRepoDropdownOptions(dropdowns);
                setFilteredData(dropdowns);
            } else {
                setRepoDropdownOptions([]);
            }
            setLoading(false);
            setHasUpdated(!hasUpdated);
        } catch (error) {
            recordError(error);
        }
    };

    const handleActivation = async (action, data) => {
        try {
            var response = null;
            // reset some attributes
            data.active = !data.active;
            data.key = data.id;

            switch (data.dropdown) {
                case "Category":
                case "Document Category":
                    response = await service.updateDocumentCategory(data);
                    break;
                case "Document Type":
                    response = await service.updateDocumentType(data);
                    break;
                case "Affiliated Organisation":
                case "Affiliated Organization":
                case "Funding Agency":
                default:
                    response = await service.activateOganisation(data);
                    break;
            }

            if (response && response.status === 200) {
                const _actioned = action.toLowerCase() + "d";
                msg = util.parseMessages(Messages.UPDATE_STATUS, "Dropdown option", _actioned);
                openNotification("Document Dropdown Configuration", msg, Notify.SUCCESS);
                setHasUpdated(!hasUpdated);
                return;
            }

            msg = util.parseMessage(Messages.ADD_FAILURE, "Document Dropdown Option");
            openNotification("Document Dropdown Configuration", msg, Notify.ERROR);
        } catch (error) {
            recordError(error);
        }
    };

    const handleInputChange = (e) => {
        const { value: searchValue } = e.target;
        setSearchText(searchValue);
        globalSearch(searchValue);
    };

    const globalSearch = (searchValue) => {
        if (searchText === "") {
            setFilteredData(repoDropdownOptions);
            return;
        }

        const reg = new RegExp(searchValue.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"), "gi");

        var _filteredData = map(repoDropdownOptions, (record) => {
            const nameMatch = get(record, "name").match(reg);
            const dropdownMatch = get(record, "dropdown").match(reg);

            const noMatch = (!nameMatch && !dropdownMatch);
            return noMatch ? null : record;
        }).filter((record) => record);

        setSearchText(searchValue);
        setFilteredData(_filteredData);
    };

    const cancel = () => {
        // var msg = util.parseMessage(Messages.UPDATE_CANCELLED);
        // openNotification("Action cancelled successfully", msg, Notify.WARNING);
    };

    const onRowChange = (row) => {
        setPageSize(row.pageSize);
    };

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name-1",
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            sorter: (a, b) => {
                return a.name.localeCompare(b.name);
            },
        },
        {
            title: "Associated Dropdown",
            dataIndex: "dropdown",
            key: "dropdown-2",
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            sorter: (a, b) => {
                return a.dropdown.localeCompare(b.dropdown);
            },
        },
/*         {
            title: "Published Date",
            dataIndex: "publishedDate",
            key: "3",
            render: (text) => {
                return text != null ? moment(text).format("DD MMM YYYY, HH:mm") : "";
            },
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            sorter: (a, b) => {
                return a.uploadDate > b.publishedDate;
            },
        }, */
        {
            title: "Active",
            dataIndex: "active",
            key: "archived-2",
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            sorter: (a, b) => {
                return a.active - b.active;
            },
            render: (value) => (<CheckboxSwitchery checked={value} disabled={true} />),
            uploads: true,
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions-3",
            showOnResponse: true,
            showOnDesktop: true,
            render: (_, record) => {
                const action = record.active ? "Deactivate" : "Activate";
                return (
                    <>
                        <a key={"repo-doc" + record.id} onClick={() => showModal(record, "edit")} >Edit</a>
                        <Popconfirm
                            key= "pcl-4"
                            title={"Are you sure you want to " + action + " this option?"}
                            onConfirm={() => handleActivation(action, record)}
                            onCancel={() => cancel()}
                            okText="Yes"
                        >
                            <a key={"del-" + record.id} style={{ marginLeft: 10 }}>{action}</a>
                        </Popconfirm>
                    </>
                );
            },
        },
    ];

    return (
        <>
            <div className="space"></div>
            <div>List of document dropdowns</div>
            <SearchControl handleInputChange={handleInputChange} searchText={searchText} />
            <div className="space"></div>

            <Table
                // dataSource={loading ? [] : filteredData}
                dataSource={filteredData}
                locale={{
                    emptyText: loading ? <Skeleton active={true} /> : <Empty />,
                }}
                rowKey={(record) => "row-" + record.dropdown + "-" + record.id}
                columns={columns}
                bordered
                pagination={{ pageSize: pageSize }}
                onChange={onRowChange}
                size="middle"
                mobileBreakPoint={768}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {
                        }, // click row
                    };
                }}
            />
        </>
    )
}
